export default "__VITE_ASSET__DkxKAFdp__"